import {EntityService} from '../../../service/EntityService';

export class DeviceService extends EntityService {

  static entity = 'app/device';
}
